import React from 'react';
import {
  Button,
  Card,
  Tab,
} from "@chakra-ui/react";

// Constants
export const goldColor = "#FFD700";
export const grayTextColor = "gray.400";

// Styled components
export const PirateCard = ({ children, ...props }) => (
  <Card
    bg="gray.800"
    borderWidth="1px"
    borderColor="rgba(255, 215, 0, 0.3)"
    borderRadius="xl"
    boxShadow="0 0 20px rgba(255, 215, 0, 0.1)"
    _hover={{
      borderColor: "rgba(255, 215, 0, 0.5)",
      boxShadow: "0 0 30px rgba(255, 215, 0, 0.2)",
    }}
    transition="all 0.3s"
    {...props}
  >
    {children}
  </Card>
);

export const PirateButton = ({ children, ...props }) => (
  <Button
    color={goldColor}
    borderColor={goldColor}
    variant="outline"
    _hover={{
      bg: "rgba(255, 215, 0, 0.1)",
    }}
    {...props}
  >
    {children}
  </Button>
);

export const PirateTab = ({ children, ...props }) => (
  <Tab
    _selected={{
      color: "white",
      borderColor: "rgba(255, 215, 0, 0.5)",
      bg: "rgba(255, 215, 0, 0.1)",
    }}
    {...props}
  >
    {children}
  </Tab>
);
